import { watchSurfClock } from "../conditions/visualiser/surf-freshness";
import { MOUNTAIN_SPORTS, type MountainSport } from "./types";
import { mountainDates } from "./forecast/presentation";
export type MountainSelection = { date: string; hour: number };
export function readMountainSelection(
  date: string | null,
  hour: string | null,
  today: string,
  nowHour: number,
): MountainSelection {
  return {
    date: date && mountainDates(today).includes(date) ? date : today,
    hour:
      hour !== null && /^(?:[0-9]|1[0-9]|2[0-3])$/.test(hour)
        ? Number(hour)
        : nowHour,
  };
}

/** The optional winter pilot must not change MTB's selection or suppression rules. */
export function mountainPilotActive(
  slug: string,
  available: boolean,
  sport: string,
): boolean {
  return (
    slug === "zermatt" &&
    available &&
    MOUNTAIN_SPORTS.includes(sport as MountainSport)
  );
}
/** Keep hydration stable, then immediately age cached evidence against the live clock. */
export function watchMountainClock(
  onChange: (now: number) => void,
): () => void {
  onChange(Date.now());
  return watchSurfClock(onChange);
}
